import { CallPlayer } from './CallPlayer';

export default CallPlayer;
